export interface QuizResult {
  total: number;
  ok: number;
  rate: number;
}

interface Props {
  result: QuizResult;
  wrongCount: number;
  onExport: () => void;
  onClose: () => void;
  onRestart: () => void;
}

export function ResultModal({ result, wrongCount, onExport, onClose, onRestart }: Props) {
  const { total, ok, rate } = result;
  const msg = rate >= 90 ? '太出色了！' : rate >= 70 ? '表现很棒！' : rate >= 60 ? '顺利及格！' : '继续加油！';

  return (
    <div className="modal-mask" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-emoji">{rate >= 60 ? '🏆' : '📚'}</div>
        <div className="modal-title">{msg}</div>
        <div className="modal-rate">{rate}%</div>
        <div className="modal-sub">正确率 · 答对 {ok} / {total} 题</div>
        <div className="modal-actions">
          <button className="btn secondary" onClick={onClose}>再看看</button>
          {wrongCount > 0 && <button className="btn secondary" onClick={onExport}>导出错题</button>}
          <button className="btn primary" onClick={onRestart}>再练一遍</button>
        </div>
      </div>
    </div>
  );
}
